var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.388,
    height: 66.544,
    viewBox: "0 0 62.388 66.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f9c87;}.b{fill:#fffcf2;}.c{fill:#231f20;}.d{fill:#ffc8d8;}.e{fill:#f0ac3f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-775.082 -6199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(801.194 6229.962)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 18.138,
    cy: 17.791,
    rx: 18.138,
    ry: 17.791,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.544 5.603)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3270.617,4593.247h6.363a21.647,21.647,0,0,1,2.492,0c2.55.177.936.93,1.686,2.843v0c.149.38.531.611.657,1,.271.84-.792,1.589-.71,2.476.07.757.957,1.3.8,2.04-.083.395-.437.641-.624.988a3.493,3.493,0,0,0-.04,1.993c.071.673-.306,2.142-.926,2.142l-13.59-.1v-10.9a7.322,7.322,0,0,1,.64-3.38q.951-1.567,1.958-3.093a7.235,7.235,0,0,1,2.791-2.85.679.679,0,0,1,.519-.064c.351.142.352.68.272,1.08C3272.514,4589.386,3270.116,4593.247,3270.617,4593.247Z",
    transform: "translate(-3261.569 -4586.315)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3.935,
    height: 12.246,
    transform: "translate(0 7.997)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(807.063 6199)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 10.701,
    cy: 10.496,
    rx: 10.701,
    ry: 10.496,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-2280.725,4217.4a2.4,2.4,0,0,1-1.175-.609,38.29,38.29,0,0,1-3.206-2.958,11,11,0,0,1-2.139-2.678,4.029,4.029,0,0,1-.29-3.3c1.226-2.993,5.659-1.556,6.457,1.036.507-1.558,2.822-3.568,4.647-3.218a3.134,3.134,0,0,1,2.182,3.467c-.291,2.8-2.715,5.733-4.846,7.444C-2279.794,4217.141-2280.228,4217.449-2280.725,4217.4Z",
    transform: "translate(2291.627 -4200.193)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775.082 6212.332)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M4840.464,4573.6a7.661,7.661,0,1,1,7.661-7.662A7.671,7.671,0,0,1,4840.464,4573.6Zm0-14.422a6.76,6.76,0,1,0,6.759,6.76A6.767,6.767,0,0,0,4840.464,4559.173Z",
    transform: "translate(-4832.802 -4558.272)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.443eb361166a9a891f87987e6050e8be.svg";
export { ForwardRef as ReactComponent };